import React, { Component } from 'react';
import { ServiceLogin } from "../../service/Login";

export default class  ScreensLogoutForm  extends Component{

    componentWillMount(){
        ServiceLogin.logout();
    }    

    render(){
        return null;
    }
}